import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]
  static values = { openOnConnect: Boolean }

  connect() {
    if (this.openOnConnectValue && this.hasDialogTarget && !this.dialogTarget.open) {
      this.dialogTarget.showModal()
    }
  }

  open() {
    if (this.hasDialogTarget) {
      this.dialogTarget.showModal()
    }
  }

  close() {
    if (this.hasDialogTarget) {
      this.dialogTarget.close()
    }
  }
}
